const {
  default: messages,
} = await import('./messages.json', { with: { type: 'json' } });

export default messages;
